import { FC } from 'react';
import { IconColor, IconProps } from '../types';

export const NumberSymbol: FC<IconProps> = ({
  width = 15,
  height = 12,
  fillColor = IconColor.TEXT_PRIMARY,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 12"
      fill={fillColor}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_6509_77739)">
        <path
          d="M0.86377 12V0.575989H2.47977L7.67977 9.98399H7.74377C7.7331 9.70666 7.7171 9.38666 7.69577 9.02399C7.67444 8.66132 7.65844 8.29866 7.64777 7.93599C7.6371 7.56266 7.63177 7.24266 7.63177 6.97599V0.575989H8.89577V12H7.32777L2.06377 2.55999H1.99977C2.0211 2.83732 2.0371 3.16799 2.04777 3.55199C2.0691 3.92532 2.0851 4.29866 2.09577 4.67199C2.1171 5.04532 2.12777 5.37599 2.12777 5.66399V12H0.86377ZM10.4158 12V10.896H14.5278V12H10.4158ZM12.4638 9.85599C12.0051 9.85599 11.5944 9.75466 11.2318 9.55199C10.8798 9.33866 10.6024 9.02932 10.3998 8.62399C10.1971 8.21866 10.0958 7.72266 10.0958 7.13599C10.0958 6.26132 10.3091 5.59466 10.7358 5.13599C11.1731 4.66666 11.7651 4.43199 12.5118 4.43199C12.9704 4.43199 13.3758 4.53866 13.7278 4.75199C14.0904 4.95466 14.3731 5.25866 14.5758 5.66399C14.7891 6.05866 14.8958 6.54932 14.8958 7.13599C14.8958 8.01066 14.6771 8.68266 14.2398 9.15199C13.8024 9.62132 13.2104 9.85599 12.4638 9.85599ZM12.4958 8.92799C12.9651 8.92799 13.3011 8.77866 13.5038 8.47999C13.7064 8.17066 13.8078 7.72266 13.8078 7.13599C13.8078 6.53866 13.7064 6.10132 13.5038 5.82399C13.3011 5.53599 12.9651 5.39199 12.4958 5.39199C12.0371 5.39199 11.7011 5.53599 11.4878 5.82399C11.2744 6.10132 11.1678 6.53866 11.1678 7.13599C11.1678 7.72266 11.2691 8.17066 11.4718 8.47999C11.6851 8.77866 12.0264 8.92799 12.4958 8.92799Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_6509_77739">
          <rect width="15" height="12" fill={fillColor || 'white'} />
        </clipPath>
      </defs>
    </svg>
  );
};
